<template>
  <div>
    <v-data-table
      :items="items"
      :headers="headers"
      :server-items-length="count"
      :options="pagination"
      :loading="loading"
      @update:page="move"
      :footer-props="{
        'disable-items-per-page': true,
        'items-per-page-options': []
      }"
    >
      <template v-slot:top="{ pagination, options }">
        <v-data-footer
          @update:options="move($event.page)"
          :pagination="pagination"
          :options="options"
          disable-items-per-page
          :items-per-page-options="[]"
        ></v-data-footer>
        <v-divider></v-divider>
      </template>
      <template v-slot:item.identityNo="{ item }">
        {{ item.identityNo }}
        <template v-if="item.deviceType === 13 || item.identityNo === 1229874051 || item.identityNo === 1223286623 || item.identityNo === 1223286626">
          <v-btn icon :to="`/devices/${item.identityNo}/monitor`"><v-icon>mdi-magnify-scan</v-icon></v-btn>
        </template>
      </template>
      <template v-slot:item.company="{ item }">
        <v-chip label small>{{ item.company || '미등록' }}</v-chip>
      </template>
      <template v-slot:item.edit="{ item }">
        <v-btn icon :to="getEditPath(item.id)"><v-icon>mdi-pencil</v-icon></v-btn>
      </template>
      <template v-slot:item.tags="{ item }">
        <v-chip v-for="tag in item.tags" :key="tag.id" label small class="ml-1">
          {{ tag.value }}
        </v-chip>
      </template>
    </v-data-table>

    <v-divider></v-divider>
  </div>
</template>

<script>
import { getDevices } from '@/api'
import { getPaginationParams } from '@/utils'

export default {
  data () {
    return {
      devices: [],
      count: 0,
      loading: false,
      headers: [
        {
          text: '모뎀 번호',
          value: 'identityNo'
        },
        {
          text: '장치 유형',
          value: 'deviceType'
        },
        {
          text: '모델명',
          value: 'modelNo'
        },
        {
          text: '버전',
          value: 'version'
        },
        {
          text: '소속',
          value: 'company'
        },
        {
          text: '태그',
          value: 'tags',
          sortable: false
        },
        {
          text: '편집',
          value: 'edit',
          sortable: false
        }
      ],
      pagination: {
        page: 1,
        itemsPerPage: 30
      }
    }
  },
  computed: {
    items () {
      return this.devices.map(device => ({
        ...device,
        company: device.company ? device.company.name : null,
        updatedAt: this.$moment(device.updatedAt).format('YYYY-MM-DD HH:mm')
      }))
    }
  },
  async beforeRouteEnter (to, from, next) {
    let page = parseInt(to.query.page, 10) || 1
    if (page < 1) page = 1

    const params = getPaginationParams(to)
    try {
      const { items, count } = await getDevices(params)

      next(vm => {
        vm.devices = items
        vm.count = count
        vm.pagination.page = page
      })
    } catch (err) {
      next()
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      await this.fetch(to)
      next()
    } catch (err) {
      next()
    } finally {
      this.loading = false
    }
  },
  methods: {
    async fetch (route) {
      this.loading = true
      const params = getPaginationParams(route)

      try {
        const { items, count } = await getDevices(params)

        this.devices = items
        this.count = count
      } finally {
        this.loading = false
      }
    },
    move (page) {
      if (page !== this.pagination.page) {
        this.pagination.page = page
        this.$router.push({ query: { page } })
      }
    },
    getEditPath (id) {
      return `/devices/${id}/edit`
    }
  }
}
</script>
